// components/Snackbar.tsx
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Snackbar, Alert } from "@mui/material";
import { RootState } from "../../store";
import { closeSnackbar } from "../../store/slices/snackbarSlice";

const AppSnackbar: React.FC = () => {
    const dispatch = useDispatch();
    const { open, message, severity, autoHideDuration } = useSelector(
        (state: RootState) => state.snackbar
    );

    const handleClose = () => {
        dispatch(closeSnackbar());
    };

    return (
        <Snackbar
            open={open}
            autoHideDuration={autoHideDuration}
            onClose={handleClose}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }} // <-- change here
        >
            <Alert onClose={handleClose} severity={severity} variant="filled">
                {message}
            </Alert>
        </Snackbar>
    );
};

export default AppSnackbar;
